import React, { FC } from 'react';
import Footer from 'components/layout/footer';
import Header from 'components/layout/header';

const PrivateLayout: FC = ({ children }) => {
  return (
    <div className="app app-layout-private">
      <Header />
      <div className="app-content">
        <div className="container">
          {children}
        </div>
        <div id="review-buttons" className="review-buttons" />
      </div>
      <Footer />
    </div>
  );
};

export default PrivateLayout;